/*
 * 同步树组件
 */
import React, { Fragment } from "react";
import { BaseComponent } from "@platform/template";
import { tinperClsPrefix } from '@platform/api';
import { Tree, Icon, Tooltip, Modal, Button, SvgIcon, Menu, Dropdown, HotKeys } from '@platform/base';
import { promptBox } from '../PromptBox';
import classnames from 'classnames';
import * as TreeUtils from './util';
import {
    isFunction,
    getMultiLang,
    getSysFieldid,
    getGlobalStorage,
    microAppUtil,
} from "@platform/api";
import Form from '@platform/form';
import TreeNodeToolTip from "./TreeNodeToolTip";
import { isObject } from "../../api/utils";
const { Item } = Menu;
const TreeNode = Tree.TreeNode;
require("./Tree.less");

export default class SyncTree extends BaseComponent {
    constructor(props) {
        super(props);
        this.searchInputRef = null;
        this.searchRef = React.createRef();
        this.treeRef = React.createRef();
        this.ncc_automated = "0";
        this.dropped = false;
        this.state = {
            langJson: {},
            _: "",
        };
        this.ncc_automated = getGlobalStorage("localStorage", "_ncc_automated_");

        //业务初始化数据 存store
        let { store, meta, metaId, treeType, formStore } = this.props;

        store.setCache('treeType', treeType);

        store.setStore('formStore', formStore);

        store.setStore("searchInputRef", this.searchRef);
        store.setStore("treeRef", this.treeRef);

        if (metaId && meta[metaId]) {
            formStore.setMeta(meta, metaId);
        }
        this.transerDefaultConfigToStore(props);
    }

    componentDidMount() {
        let { store, treeType, defaultExpandAll } = this.props;
        store?.setRef(this);
        this.handleFirst(treeType, store, defaultExpandAll);
        let searchInput = store.getStore('searchInputRef');
        if (searchInput?.current) {
            searchInput.current.value = store.getStore('searchValue');
        }
    }

    componentWillMount() {
        //调用多语
        let callback = json => {
            this.setState({ langJson: json });
        };

        getMultiLang({ moduleId: ["containers_tree", "page-button"], callback });

    }

    componentWillUpdate(newProps, newState) {
        let { store, defaultExpandAll, treeType } = newProps;
        // if (treeType === 'syncTree') {
        //     let firstTime = store.getStore("firstTime");
        //     let treeData = store.getStore("treeData");
        //     if (firstTime) {
        //         this.generateList(treeData, this.dataList);
        //         store.setCache("dataList", this.dataList);
        //         store.setStore("firstTime", false);
        //         if (defaultExpandAll) {
        //             store.setStore("expandedKeys", TreeUtils.getAllNodeKeys(treeData));
        //         }
        //     }
        //     // let searchValue = store.getStore('searchValue');
        //     // if(searchValue){}
        // }
        let shouldHandleExpand = this.props.defaultExpandAll !== defaultExpandAll;
        this.handleFirst(treeType, store, defaultExpandAll, shouldHandleExpand);

    }

    componentWillReceiveProps(nextProps) {
        let { meta, store, metaId } = nextProps;
        let formStore = store.getStore('formStore');
        if (metaId && meta[metaId]) {
            formStore.setMeta(meta, metaId);
        }
        this.transerDefaultConfigToStore(nextProps);
    }

    transerDefaultConfigToStore = props => {
        this.listeners = [
            'onTreeStatusChange', 'selectedForInit', 'onSelectEve', 'onMouseEnterEve',
            'onSelectedChange', 'clickAddIconEve', 'clickEditIconEve', 'clickDelIconEve',
            'loadTreeData', //异步树
            'overWriteFilterTree', 'onSetTreeDataEve'
        ];
        this.listeners.forEach(item => {
            if (typeof props[item] !== 'undefined') {
                this.props.store.setListener([item], props[item]);
            }
        });

        this.lastData = [];//记录上次点击节点
        this.dataList = [];

        //业务初始化数据 存store
        let { store } = this.props;
        this.cacheProps = ['showModal', 'userControlIcon', 'metaId', 'disabledSearch', 'searchType', 'noCheckWhenSelect'];
        this.cacheProps.forEach(item => {
            if (typeof props[item] !== 'undefined') {
                store.setCache([item], props[item]);
            }
        });

        if (typeof props.needEdit !== 'undefined') {
            store.setStore('needEdit', props.needEdit);
        }
    }

    //  拆分数据，用于查询关键字
    generateList = (data, dataList) => {
        for (let i = 0; i < data.length; i++) {
            let node = data[i];
            let key = node.key || node.id || node.refpk;

            let beforeName = node.beforeName ? node.beforeName : '';
            let afterName = node.afterName ? node.afterName : '';
            let resetIcon = !this.props.store.getCache('userControlIcon');
            TreeUtils.addIsLeaf([node], { resetIcon });
            let name = node.refname ? node.refname : '';

            if (typeof beforeName === 'string') {
                name = beforeName + name;
            }

            if (typeof afterName === 'string') {
                name = name + afterName;
            }
            dataList.push({
                key,
                title: name,
                isleaf: node.isleaf,
            });
            if (node.children) {
                this.generateList(node.children, dataList);
            }
        }
    };

    // 第一次设置dataList
    handleFirst = (treeType, store, defaultExpandAll, shouldHandleExpand) => {
        if (treeType === 'syncTree') {
            let firstTime = store.getStore("firstTime");
            let treeData = store.getStore("treeData");
            if (firstTime || shouldHandleExpand) {
                this.generateList(treeData, this.dataList);
                store.setCache("dataList", this.dataList);
                store.setStore("firstTime", false);
                if (defaultExpandAll) {
                    store.setStore("expandedKeys", TreeUtils.getAllNodeKeys(treeData));
                }
                this.forceUpdate();
            }
            // let searchValue = store.getStore('searchValue');
            // if(searchValue){}
        }
    }

    //---------搜索框事件--------------//
    handleClearState = () => {
        let { store, treeType, resetExpandedKeysWhenInput, expandParent } = this.props;
        store.setStore('searchValue', '');
        if (resetExpandedKeysWhenInput) {
            store.setStore('expandedKeys', []);
        } else {
            store.setStore('expandedKeys', store.getCache('saveExpandedKeys'));
        }
        if (treeType === "syncTree") {
            store.setStore('treeData', store.getCache('deepData'));

        }
        store.searchChange('', true, resetExpandedKeysWhenInput, expandParent);
    }

    handleClearSearchVal = () => {
        let { getSearchVal, clearSearchVal, store } = this.props;
        // 处理清空状态
        this.handleClearState();
        store.setStateEve(() => {
            if (this.searchInputRef) {
                this.searchInputRef.value = '';
                this.searchInputRef.focus();
            }
        });
        if (isFunction(clearSearchVal)) {
            clearSearchVal();
        }
        if (isFunction(getSearchVal)) {
            getSearchVal(store.getStore('searchValue'));
        }
    }

    focusEve = () => {
        // let { store } = this.props;
        // let expandedKeys = store.getStore('expandedKeys');
        // let checkedKeys = store.getStore('checkedKeys');
        // if (store.getStore('treeData').length != store.getCache('deepData').length) return;
        // store.setCache('saveExpandedKeys', JSON.parse(JSON.stringify(expandedKeys)));
        // store.setCache('saveCheckedKeys', JSON.parse(JSON.stringify(checkedKeys)));
        const { store } = this.props;
        const value = this.searchInputRef.current?.value;
        if ((!value || value == '') && value !== '0') {
            let expandedKeys = store.getStore('expandedKeys');
            store.setCache('saveExpandedKeys', JSON.parse(JSON.stringify(expandedKeys)));
        }
    }

    //----------树组件事件------------------//
    onDoubleClickHandler = (pk, node) => {
        let { onDoubleClickEve, store } = this.props;
        if (isFunction(onDoubleClickEve)) {
            let item = null;
            if (pk) {
                let treeData = store.getStore('treeData');
                item = TreeUtils.getItem(treeData, pk);
            }
            onDoubleClickEve(pk, node, item);
        }

        this.expandedRows(pk, node);
    }

    // 双击行展开节点
    expandedRows = (pk, node, fromClick = false) => {
        let { store, expandWhenDoubleClick, toggleExpand = true } = this.props;
        if (expandWhenDoubleClick && !fromClick) {
            return;
        }
        let expandedKeys = store.getStore('expandedKeys');

        let selectedItemKeys = node.node.props.refpk;
        let copy = JSON.parse(JSON.stringify(expandedKeys));

        if (toggleExpand) {
            if (copy.indexOf(selectedItemKeys) === -1) {
                copy.push(selectedItemKeys);
            } else {
                copy.map((v, i) => {
                    if (v === selectedItemKeys) { copy.splice(i, 1); }
                });
            }
        }

        this.onExpand(copy, node);
    };

    //  节点展开事件
    onExpand = (expandedKeys, info) => {
        let { store, onTreeExpand, onNodeOpenOrClose } = this.props;
        store.setStore('expandedKeys', expandedKeys);
        store.setStore('autoExpandParent', false);
        store.setStateEve();

        if (isFunction(onTreeExpand) || isFunction(onNodeOpenOrClose)) {
            let treeData = store.getStore('treeData');
            let refpk = info.node.props.refpk,
                item = TreeUtils.getItem(treeData, refpk);
            if (isFunction(onTreeExpand)) {
                onTreeExpand(expandedKeys, info, { item });
            }
            if (isFunction(onNodeOpenOrClose)) {
                onNodeOpenOrClose(item, info.expanded);
            }
        }
    };

    onSelect = (pk, node) => {
        let {
            onSelectCallBack,
            onSelectAndChecked,
            onSelectedChange,
            onSelectEve,
            onCheckEve,
            store,
            treeType,
            pageOutput,
            triggerCheckWhenSelect,
            alwaysSelect = false,
            checkStrictly,
            checkCurrentWhenSelect = false,
            needExpandWhenClick = false,
            checkable
        } = this.props;

        pk = Array.isArray(pk) && pk.length === 0 ? [node.node.props.refpk] : pk;

        //经营会计 王建卫  利润中心成本动因 公式编辑器
        if (isFunction(onSelectCallBack)) {
            onSelectCallBack(pk, node);
        }

        //处理预算单击收起/展开问题
        if (needExpandWhenClick) {
            this.expandedRows(pk, node, true);
        }

        if (!node.selected && !alwaysSelect) { return; }
        store.setStore('selectedKeys', pk);
        let checkedKeys = store.getStore('checkedKeys');
        let treeData = store.getStore('treeData');
        let item = TreeUtils.getItem(treeData, pk[0]);
        //------------TODO: 同步树逻辑，异步树没有
        //勾选节点操作，判断checkedKeys数组是否只有一个成员，如果有就勾选
        let noCheckWhenSelect = store.getCache('noCheckWhenSelect');
        if (checkedKeys.length < 2 && !noCheckWhenSelect) {
            if (!checkCurrentWhenSelect) {
                if (checkStrictly === false) {
                    checkedKeys = TreeUtils.getChildrenPk(treeData, pk[0], true);
                } else {
                    checkedKeys = pk;
                }
            } else {
                checkedKeys = pk;
            }
            store.setStore('checkedKeys', checkedKeys);
            let saveCheckedKeys = store.getCache("saveCheckedKeys");
            if (checkable) {
                store.setCache("saveCheckedKeys", [...new Set([...saveCheckedKeys, ...pk])]);
            }else {
                store.setCache("saveCheckedKeys", [...new Set(pk)]);
            }
            
            //triggerCheckWhenSelect 设置选中时触发勾选回调
            if (triggerCheckWhenSelect) {
                let { selectedNodes, node: checkedNode } = node;
                typeof onCheckEve === 'function' && onCheckEve({ ...this.props, ...pageOutput }, [...checkedKeys], {
                    checked: true,
                    checkedNodes: selectedNodes,
                    node: checkedNode,
                    event: "check",
                }, { item });
            }
            if (onSelectAndChecked) {
                onSelectAndChecked(pk);
            }
        }
        //------------TODO: 同步树逻辑，异步树没有

        // let treeData = store.getStore('treeData');

        let isChange = () => this.lastData[0] !== pk[0];

        if (isChange()) {
            if (onSelectedChange) {
                onSelectedChange(item);
            }
        }
        if (pk.length !== 0) {
            store.setCache('selectedNode', item);
        }
        if (typeof onSelectEve === 'function') {
            if (treeType === "syncTree") {
                onSelectEve(item.refpk, item, isChange(), node);
            } else {
                onSelectEve(item.refpk, item, isChange(), node);
            }
            this.lastData[0] = pk[0] || item.refpk;
        }
        store.setStateEve();
    }

    // 展开子元素事件
    onLoadData = treeNode => {
        let { loadTreeData, store } = this.props;
        if (isFunction(loadTreeData)) {
            return new Promise(resolve => {
                let refpk = treeNode.props.eventKey;
                let treeData = store.getStore('treeData'),
                    item = TreeUtils.getItem(treeData, refpk);
                loadTreeData(refpk, treeNode, { item });
                resolve();
            });
        } else {
            return Promise.resolve();
        }
    };

    onMouseLeave = e => {
        let { store, onMouseLeaveEve } = this.props;
        let refpk = e.node.props.eventKey;
        store.setCache("isHover", '');
        if (typeof onMouseLeaveEve === "function") {
            let treeData = store.getStore('treeData'),
                item = TreeUtils.getItem(treeData, refpk);
            onMouseLeaveEve(refpk, e.node.props, { item, event: e.event });
        }
    }

    onMouseEnter = e => {
        let { store, onMouseEnterEve } = this.props;
        let { event } = e;

        //event?.target?.querySelector("span.NC_iconBox").scrollIntoView({ inline: 'end', behavior: 'smooth' });

        let refpk = e.node.props.eventKey;
        store.setCache("isHover", refpk);
        if (typeof onMouseEnterEve === 'function') {
            /* iuap没给当前节点的所有数据，先自己获取，可能会有效率问题——wangshhj */
            let treeData = store.getStore('treeData'),
                item = TreeUtils.getItem(treeData, refpk);
            onMouseEnterEve(refpk, e.node.props, { item, event: e.event });
        }
        let needEdit = store.getStore('needEdit');
        if (needEdit === null) {
            store.setStore('needEdit', true);
            store.setStateEve();
        }
    }

    // 选中节点回调
    onCheck = (checkedKeys, { checked, checkedNodes, node, event }) => {
        let { store, onCheckEve, pageOutput, checkWithCache, checkStrictly } = this.props;
        let newCheck = [];
        if(isObject(checkedKeys)){
            if (Array.isArray(checkedKeys.checked)) {
                newCheck = checkedKeys.checked;
            }
            if(Array.isArray(checkedKeys.halfChecked)){
                store.setStore('halfCheckedKeys', checkedKeys.halfChecked);
            }
        } else if (Array.isArray(checkedKeys)) {
            newCheck = checkedKeys;
        }
        let saveCheckedKeys = store.getCache("saveCheckedKeys");
        saveCheckedKeys = [...new Set([...saveCheckedKeys, ...newCheck])];
        if (checkWithCache) {
            if(!checked){
                let refpk = node.props.refpk;
                let index = saveCheckedKeys.indexOf(refpk);
                if (refpk && index !== -1) {
                    saveCheckedKeys.splice(index, 1);
                }
                //父子勾选关联的情况要移掉父节点
                if(checkStrictly === false){
                    const data = store.getStore('treeData');
                    let allParentKeys = TreeUtils.getAllParentKey(refpk, data);
                    allParentKeys.forEach(parentPK => {
                        let parentIndex = saveCheckedKeys.indexOf(parentPK);
                        if (parentIndex !== -1) {
                            saveCheckedKeys.splice(parentIndex, 1);
                        }
                    });
                }
            }
            store.setCache("saveCheckedKeys", saveCheckedKeys);
        }else{
            store.setCache("saveCheckedKeys", newCheck);
        }
        store.setStore("checkedKeys", newCheck);
        typeof onCheckEve === 'function' &&
            //TODO page参数
            onCheckEve({ ...this.props, ...pageOutput }, newCheck, {
                checked,
                checkedNodes,
                node,
                event,
            }, saveCheckedKeys);
        store.setStateEve();
    }

    onDragOver = ({ event }) => {
        if(event){
            event.preventDefault && event.preventDefault();
            event.stopPropagation();
            if(event.nativeEvent){
                event.nativeEvent.stopImmediatePropagation();
            }
        }          
        return false;
    }
    onDragEnter = (info) => {
        console.log('QQQQQQQQQQQQ');
        console.log(info);
        let { store, treeType } = this.props;
        let { event, node, expandedKeys, dropPosition } = info;
        if(treeType === 'asyncTree'){
            let curexpandedKeys = [];
            expandedKeys.forEach(e => {
                if(e !== node.props.eventKey){
                    curexpandedKeys.push(e)
                }
            })
            if(node.props.expanded){
                curexpandedKeys.push(node.props.refpk)
            }

            store.setStore('expandedKeys', curexpandedKeys);
            store.setStore('autoExpandParent', false);
            store.setStateEve();
    
            setTimeout(() => {
                store.setStore('expandedKeys', curexpandedKeys);
                store.setStore('autoExpandParent', false);
                store.setStateEve();
            }, 100);
        }
    }
    onDragStart = ({ event, node }) => {
        this.dropped = false;
        let { store, onDragStartEve } = this.props;
        store.setCache("moveKey", node.props.eventKey);

        if (isFunction(onDragStartEve)) {
            onDragStartEve({ event, node });
        }
    }

    onDrop = info => {
        let { store, needDrop = true, onlyChangePosition } = this.props;
        this.dropped = true; // 如果正常拖动松手时，这个方法一定会执行，且在onDragEnd（如果也执行的话）之前执行。拖到外面时不执行。
        //如果不想拖动改变节点位置，则返回
        if (!needDrop) { return false; }
        const data = store.getStore('treeData');
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        if (data?.length && (dragKey === data[0]["refpk"] || dragKey === data[0]["key"])) {
            return false;
        }
        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item.key === key) {
                    return callback(item, index, arr);
                }
                if (item.children) {
                    return loop(item.children, key, callback);
                }
            });
        };

        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });
        if (onlyChangePosition) {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });
            ar.splice(i, 0, dragObj);
        } else {
            if (info.dropToGap) {
                let ar;
                let i;
                loop(data, dropKey, (item, index, arr) => {
                    ar = arr;
                    i = index;
                });
                ar.splice(i, 0, dragObj);
            } else {
                loop(data, dropKey, item => {
                    item.children = item.children || [];
                    // where to insert 示例添加到尾部，可以是随意位置
                    item.children.push(dragObj);
                });
            }
        }

        store.setStore('treeData', data);
        store.setStateEve();
    }

    onDragEnd = info => {
        let { store, onDragEndEve } = this.props;
        if (!this.dropped) {
            store.setStateEve();
        }
        if (isFunction(onDragEndEve)) {
            onDragEndEve(info);
        }
    }

    getFloadIcon = item => {
        let { store, hiddenDefaultIcon = false, customerFloadIcon } = this.props;
        let expandedKeys = store.getStore('expandedKeys');

        let floadIcon = null;
        if (!hiddenDefaultIcon) {
            if (item.isleaf == false || (item.children && item.children.length != 0)) {
                floadIcon = expandedKeys.includes(item.refpk) ? (
                    // <i
                    //     className={classnames(
                    //         'icon iconfont  icon-wenjianjiadakai tree-wenjian',
                    //         { 'stop-node': item.iconBox && item.iconBox.stopUpIon === 'stop' },
                    //     )}
                    // />
                    <SvgIcon type="kaiqi" />
                ) : (
                    // <i
                    //     className={classnames(
                    //         'icon iconfont  icon-wenjianjia tree-wenjian',
                    //         { 'stop-node': item.iconBox && item.iconBox.stopUpIon === 'stop' },
                    //     )}
                    // />
                    <SvgIcon type="guanbi" />
                );
            } else {
                floadIcon = (
                    <i
                        className={classnames(`tree-dian ${item.className ? item.className : ''}`, {
                            'stop-node-dian':
                                item.iconBox && item.iconBox.stopUpIon === 'stop',
                        })}
                    />
                );
            }
        } else if (typeof customerFloadIcon === "function") {
            floadIcon = customerFloadIcon(item, expandedKeys);
        }

        return floadIcon;
    }

    getStopUpIcon = item => {
        let { langJson } = this.state;
        let { nodeIconTooltips = {}, _this } = this.props;
        if (item && item.iconBox && item.iconBox.stopUpIon) {
            return item.iconBox.stopUpIon === 'up' ? (
                <TreeNodeToolTip
                    overlay={nodeIconTooltips.unlock || langJson['tree-node-icon-lock']}
                >
                    <i
                        className="icon iconfont icon-tingyong1 stop-icon"
                        onClick={e => {
                            TreeUtils.iconClick({
                                item,
                                _this,
                                langJson,
                                currentKey: 'up',
                                onClick: () => { item.disabled !== true && this.handleStopAndUp(item, 'up', e); },
                            });

                        }}
                    />
                </TreeNodeToolTip>
            ) : (
                <TreeNodeToolTip
                    overlay={nodeIconTooltips.lock || langJson['tree-node-icon-unlock']}
                >
                    <i
                        className="icon iconfont icon-qiyong1 stop-icon"
                        onClick={e => {
                            TreeUtils.iconClick({
                                item,
                                _this,
                                langJson,
                                currentKey: 'stop',
                                onClick: () => { item.disabled !== true && this.handleStopAndUp(item, 'stop', e); },
                            });

                        }}
                    />
                </TreeNodeToolTip>
            );
        }

        return null;
    }

    handleStopAndUp = (item, type, e) => {
        let { clickStopIconEve, clickUpIconEve, store } = this.props;
        e.stopPropagation();
        //let getStopUpStatus = item.iconBox;
        switch (type) {
            case 'stop':
                if (isFunction(clickStopIconEve)) {
                    clickStopIconEve(item);
                }
                // getStopUpStatus.stopUpIon = 'up';
                break;
            case 'up':
                if (isFunction(clickUpIconEve)) {
                    clickUpIconEve(item);
                }
                //getStopUpStatus.stopUpIon = 'stop';
                break;
        }

        store.setStateEve();

    }

    getRightIcon = item => {
        let { nodeRightOpt } = this.props;
        if (nodeRightOpt && item.isdrag) {
            return <span
                className="NC_iconBox node_right_opt"
                onClick={event => nodeRightOpt.callback(event, item)}
            >
                <Icon type={nodeRightOpt.icon} />
            </span>;
        }
        return null;
    }

    getTitleInfo = (item, name, searchValue, index, nodeLevel, beforeName, afterName) => {
        let { tooltipLevels = [], tooltipField } = this.props;
        let keywords = ["\\", "$", "(", ")", "*", "+", ".", "[", "]", "?", "^", "{", "}", "|"],
            titleInfo = null,
            newSearchArr = [],
            newSearchValue = '';
        for (let key of searchValue) {
            if (keywords.includes(key)) {
                newSearchArr.push('\\' + key);
            } else {
                newSearchArr.push(key);
            }
        }
        newSearchValue = newSearchArr.join('');
        if (index > -1 && searchValue) {
            let reg;
            try {
                reg = new RegExp(newSearchValue, "i");
            } catch (ex) {
                reg = new RegExp("\\" + newSearchValue, "i");
            }

            let matchArr = name.match(reg);
            //先从配置到的位置分割
            let res = [], startIndex = 0;
            res.push(name.slice(startIndex, matchArr.index));
            res.push(<span className="nc-tree-searchable-filter">{matchArr[0] || newSearchValue}</span>);
            startIndex = matchArr.index + searchValue.length;
            
            // for (let m of matchArr) {
            //     res.push(name.slice(startIndex, m.index));
            //     res.push(<span className="nc-tree-searchable-filter">{m[0] || newSearchValue}</span>);
            //     startIndex = m.index + searchValue.length;
            // }
            if (startIndex < name.length) {
                res.push(name.slice(startIndex));
            }

            titleInfo = <span
                fieldid={getSysFieldid('tree-title')}
                className={classnames('title-middle', {
                    'stop-node-title': item.iconBox && item.iconBox.stopUpIon === 'stop',
                    'node-title-disabled': item.treeDisabled === 'Y',
                })}
            >
                {/* {beforeStr}
                <span className="nc-tree-searchable-filter">{searchFromName}</span>
                {afterStr} */}
                {res}

            </span>;
        } else {
            titleInfo = <span
                fieldid={getSysFieldid('tree-title')}
                className={classnames('title-middle', {
                    'stop-node-title': item.iconBox && item.iconBox.stopUpIon === 'stop',
                    'node-title-disabled': item.treeDisabled === 'Y',
                })}
            >{beforeName && typeof beforeName === 'string' ? item.beforeName : ''}{item.refname}{afterName && typeof afterName === 'string' ? item.afterName : ''}
            </span>;
        }

        // 新需求: 节点根据设置的字段和层级显示 tooltip
        if (
            Array.isArray(tooltipLevels) &&
            tooltipLevels.includes(nodeLevel) &&
            tooltipField &&
            item[tooltipField]
        ) {

            titleInfo = (
                <Tooltip
                    className="tooltip-word-color"
                    placement="top"
                    delayShow={300}
                    delay={1}
                    inverse
                    overlay={item[tooltipField]}
                >
                    {titleInfo}
                </Tooltip>
            );
        }

        return titleInfo;
    }

    createCustomerTreeIcon = item => {
        let { store, customizeIconClick } = this.props;
        let treeData = store.getStore('treeData');
        let customerIcons = item.customerIcons;
        return (
            <span className='NC_iconBox'>
                {
                    customerIcons.map((value, index) => {
                        if (typeof value === "string") {
                            return (
                                <i
                                    key={index}
                                    className={`icon iconfont icon-${value} customer-icon`}
                                    onClick={e => {
                                        if (isFunction(customizeIconClick)) {
                                            customizeIconClick({ e, iconType: value, item, treeData });
                                        }
                                    }}
                                />

                            );
                        } else if (typeof value === "object") {
                            return (
                                <TreeNodeToolTip
                                    overlay={value.title}
                                >
                                    <i
                                        key={index}
                                        className={`icon iconfont icon-${value.icon} customer-icon ${value.className ? value.className : ''}`}
                                        onClick={e => {
                                            if (isFunction(customizeIconClick)) {
                                                customizeIconClick({ e, iconType: value.icon, item, treeData });
                                            }
                                        }}
                                    />
                                </TreeNodeToolTip>

                            );
                        }
                    })
                }
            </span>
        );
    }

    //TODO: 同步树与异步树不同的API
    renderTreeTitle = (item, nodeLevel) => {
        let { store, treeType, renderTreeTitle, notShowIcon } = this.props;
        let searchValue = store.getStore('searchValue');
        let noDisableId = store.getStore('noDisableId');
        let needEdit = store.getStore('needEdit');

        let editIcon, addIcon, delIcon, stopUpIon, rightIcon, iconBox;
        let beforeName = item.beforeName ? item.beforeName : '';
        let afterName = item.afterName ? item.afterName : '';
        let name = item.refname ? item.refname : '';
        let searchName = item.refname ? item.refname : '';
        if (typeof name !== "string") {
            name = item.name ? item.name : '';
        }
        if (typeof searchName !== "string") {
            searchName = item.name ? item.name : '';
        }
        if (typeof beforeName === 'string') {
            searchName = beforeName + searchName;
        }
        if (typeof afterName === 'string') {
            searchName = searchName + afterName;
        }
        let index = (searchName.toLocaleLowerCase()).indexOf(searchValue.toLocaleLowerCase());
        if (index > -1 && searchValue) {
            name = searchName;
        }
        //let floadIcon = this.getFloadIcon(item);
        let titleInfo = null;
        if (typeof renderTreeTitle === "function") {
            titleInfo = renderTreeTitle(item);
        } else {
            // if (treeType === 'asyncTree') {
            //   titleInfo = <span
            //     fieldid={getSysFieldid('tree-title')}
            //     className="title-middle"
            //   >{item.refname}</span>;
            // } else {
            titleInfo = this.getTitleInfo(item, name, searchValue, index, nodeLevel, beforeName, afterName);
            // }
        }

        //  设置树的编辑性
        // if (needEdit) {
        //     editIcon = this.getEditIcon(item);
        //     addIcon = this.getAddIcon(item);
        //     delIcon = this.getDelIcon(item);
        //     stopUpIon = this.getStopUpIcon(item);
        // }
        //右侧Icon
        rightIcon = this.getRightIcon(item);

        //老iconbox render
        // if (item.customerIcons && item.customerIcons.length > 0) {
        //     iconBox = this.createCustomerTreeIcon(item);
        // } else if (typeof item.customerIconRender === "function") {
        //     iconBox = item.customerIconRender();
        // } else {
        //     if (treeType === 'asyncTree') {
        //         iconBox = (<span className="NC_iconBox">
        //             {editIcon} {addIcon} {delIcon}
        //         </span>);
        //     } else {
        //         iconBox = (
        //             <span className="NC_iconBox">
        //                 {editIcon} {addIcon} {delIcon} {stopUpIon}
        //             </span>
        //         );
        //     }
        // }

        //新iconbox render
        iconBox = notShowIcon ? null : this.renderIconBox(item, needEdit);

        if (treeType === 'asyncTree') {
            return (
                <div className="title-con">
                    {/* {floadIcon} */}
                    {/* {beforeName} */}
                    {titleInfo}
                    {/* {afterName} */}
                    {iconBox}
                </div>
            );
        }

        if (beforeName && typeof beforeName === 'string' || afterName && typeof afterName === 'string') {
            return (
                <div
                    title={item.tooltips}
                    className={classnames(
                        `title-con ${item.className ? item.className : ''}`,
                        {
                            'active-nodisable': noDisableId === item.refpk && item.refpk,
                            'title-con-disabled': item && item.disabled,
                        },
                    )}
                >
                    {/* {floadIcon} */}
                    {titleInfo}
                    {iconBox}
                    {rightIcon}
                </div>
            );
        } else {
            return (
                <div
                    title={item.tooltips}
                    className={classnames(
                        `title-con ${item.className ? item.className : ''}`,
                        {
                            'active-nodisable': noDisableId === item.refpk && item.refpk,
                            'title-con-disabled': item && item.disabled,
                        },
                    )}
                >
                    <span className="title-single">
                        {/* {floadIcon} */}
                        {beforeName}
                        {titleInfo}
                        {afterName}
                    </span>
                    {iconBox}
                    {rightIcon}
                </div>
            );
        }
    }

    //渲染图标
    renderIconBox = (item, needEdit) => {
        if (typeof item.customerIconRender === "function") {
            //自定义render
            return item.customerIconRender();
        }
        let { store } = this.props;
        let needRenderButtons = [],
            customerIcons = store.getStore('customerIcons'),
            addBox = null,
            editBox = null,
            deleteBox = null,
            stopBox = this.getStopUpIcon(item),
            moreList = [],
            showMoreBtn = false;

        if (item.customerIcons && item.customerIcons.length > 0) {
            //自定义按钮
            if (item.customerIcons.length > 3) {
                showMoreBtn = true;
                needRenderButtons = item.customerIcons.slice(0, 2);
                moreList = item.customerIcons.slice(2);
            } else {
                needRenderButtons = item.customerIcons;
            }
        } else if (Array.isArray(customerIcons) && customerIcons.length) {
            // 注册按钮情况
            let cusIcons = [...customerIcons];
            //先找出系统预置的add edit delete
            let addIconIndex = cusIcons.findIndex(item => item.key === 'add');
            if (addIconIndex !== -1) {
                if (item.iconBox && item.iconBox.addIcon !== false) {
                    //addBox = this.getAddIcon(item);
                    item.iskeyfunc = cusIcons.find(item => item.key === 'add').iskeyfunc;
                    addBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="add" />;
                }
                cusIcons.splice(addIconIndex, 1);
            }

            let editIconIndex = cusIcons.findIndex(item => item.key === 'edit');
            if (editIconIndex !== -1) {
                if (item.iconBox && item.iconBox.editIcon !== false) {
                    //editBox = this.getEditIcon(item);
                    item.iskeyfunc = cusIcons.find(item => item.key === 'edit').iskeyfunc;
                    editBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="edit" />;
                }
                cusIcons.splice(editIconIndex, 1);
            }

            let deleteIconIndex = cusIcons.findIndex(item => item.key === 'delete');
            if (deleteIconIndex !== -1) {
                if (item.iconBox && item.iconBox.delIcon !== false) {
                    //deleteBox = this.getDelIcon(item);
                    item.iskeyfunc = cusIcons.find(item => item.key === 'delete').iskeyfunc;
                    deleteBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="del" />;
                }
                cusIcons.splice(deleteIconIndex, 1);
            }

            let existIcons = 0;
            addBox && existIcons++;
            editBox && existIcons++;
            deleteBox && existIcons++;

            if (existIcons + cusIcons.length > 3) {
                showMoreBtn = true;
                let needBtnCount = 2 - ((addBox && editBox) ? 2 : ((addBox || editBox) ? 1 : 0));
                needRenderButtons = cusIcons.slice(0, needBtnCount);
                moreList = cusIcons.slice(needBtnCount);
            } else {
                needRenderButtons = cusIcons;
            }

        } else {
            ///系统内置按钮
            if (needEdit && item.iconBox && item.iconBox.addIcon !== false) {
                //addBox = this.getAddIcon(item);
                addBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="add" />;
            }
            if (needEdit && item.iconBox && item.iconBox.editIcon !== false) {
                //editBox = this.getEditIcon(item);
                editBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="edit" />;
            }
            if (needEdit && item.iconBox && item.iconBox.delIcon !== false) {
                //deleteBox = this.getDelIcon(item);
                deleteBox = <TreeNodeIcon item={item} {...this.props} langJson={this.state.langJson} type="del" />;
            }
            if (addBox && editBox && deleteBox && stopBox) {
                showMoreBtn = true;
            }
        }

        return (
            <span className="NC_iconBox">
                {editBox}
                {addBox}
                {this.renderCustomerIcons(item, needRenderButtons)}
                {showMoreBtn && this.renderMoreList(item, moreList, stopBox, deleteBox)}
                {!showMoreBtn && deleteBox}
            </span>
        );

    }

    renderCustomerIcons = (node, needRenderButtons) => {
        let { customizeIconClick, store, _this, noBubbleClickIcon } = this.props;
        let treeData = store.getStore('treeData');
        let { langJson } = this.state;
        let iconBox = item => <span
            className="tree-icon-wrapper"
            onClick={e => {
                if (noBubbleClickIcon) {
                    e.stopPropagation();
                }
                TreeUtils.iconClick({
                    item,
                    _this,
                    langJson,
                    currentKey: item.key,
                    onClick: () => {
                        customizeIconClick && customizeIconClick({ e, iconType: item.icon, item: node, treeData });
                    },
                });
            }}>
            <i className={`icon iconfont icon-${item.icon}`} />
        </span>;
        return needRenderButtons.map(item =>
            item.title ?
                <TreeNodeToolTip overlay={item.title} key={item.key}>
                    {iconBox(item)}
                </TreeNodeToolTip>
                :
                iconBox(item),
        );
    }

    renderMoreList = (node, list, stopBox, deleteBox) => {
        let { store, customizeIconClick, nodeIconTooltips = {}, _this } = this.props;
        let visible = `${node.refpk}_visible`;
        let show = this.state[visible];
        let treeData = store.getStore('treeData');
        let { langJson } = this.state;
        return (
            <Dropdown
                trigger={['click']}
                visible={show}
                onVisibleChange={() => this.setState({ [visible]: !show })}
                overlay={(
                    <Menu>
                        <Fragment>
                            {list.map(item => (
                                <Item
                                    fieldid={item.key}
                                    btn-code={item.key}
                                    className={'tree-more-item-wrapper'}
                                    key={item.key}
                                >
                                    <span
                                        className="tree-menu-title-wrapper"
                                        onClick={e => {
                                            TreeUtils.iconClick({
                                                item,
                                                _this,
                                                langJson,
                                                currentKey: item.key,
                                                onClick: () => {
                                                    this.setState({ [visible]: !show });
                                                    customizeIconClick && customizeIconClick({ e, iconType: item.icon, item: node, treeData });
                                                },
                                            });

                                        }}
                                    >
                                        <TreeNodeToolTip
                                            overlay={item.title}>
                                            <i
                                                className={`icon iconfont icon-${item.icon}`}
                                            />
                                            <span className="icon-right-title">{item.title}</span>
                                        </TreeNodeToolTip>
                                    </span>
                                </Item>
                            ))}
                            {stopBox && <Item className={'tree-more-item-wrapper'}>
                                {this.getStopUpIconMenu(node, () => this.setState({ [visible]: !show }))}
                            </Item>}
                            {deleteBox && <Item className={'tree-more-item-wrapper'}>
                                <TreeNodeToolTip overlay={nodeIconTooltips.delete || langJson['tree-node-icon-delete']}>{this.getdeleteIconMenu(node, () => this.setState({ [visible]: !show }))}</TreeNodeToolTip>
                            </Item>
                            }
                        </Fragment>
                    </Menu>
                )}
                animation="slide-up"
                overlayClassName="dropdown-component-list fieldid_more_btn_list"
                getPopupContainer={() => microAppUtil.getDocument().querySelector(".base-tree ")}
            >
                <TreeNodeToolTip
                    overlay={langJson['tree-node-icon-more']}>
                    <span className="tree-icon-wrapper">
                        <i
                            className="icon iconfont icon-shugengduo"
                            onClick={e => this.setState({ [visible]: !show })}
                        />
                    </span>
                </TreeNodeToolTip>
            </Dropdown>
        );

    };

    getStopUpIconMenu = (item, callback) => {
        let { langJson } = this.state;
        let { nodeIconTooltips = {} } = this.props;
        if (item && item.iconBox && item.iconBox.stopUpIon) {
            return item.iconBox.stopUpIon === 'up' ? (
                <span className="tree-menu-title-wrapper" onClick={e => {
                    callback && callback();
                    item.disabled !== true &&
                        this.handleStopAndUp(item, 'up', e);
                }}>
                    <i className="icon iconfont icon-tingyong1 stop-icon" />
                    <span className="icon-right-title">{nodeIconTooltips.unlock || langJson['tree-node-icon-lock']}</span>
                </span>
            ) : (
                <span className="tree-menu-title-wrapper" onClick={e => {
                    callback && callback();
                    item.disabled !== true &&
                        this.handleStopAndUp(item, 'stop', e);
                }}>
                    <i className="icon iconfont icon-qiyong1 stop-icon" />
                    <span className="icon-right-title">{nodeIconTooltips.unlock || langJson['tree-node-icon-unlock']}</span>
                </span>
            );
        }

        return null;
    }

    getdeleteIconMenu = (item, callback) => {
        let { langJson } = this.state;
        let { nodeIconTooltips = {}, _this } = this.props;

        return <span className="tree-menu-title-wrapper"
            onClick={e => {
                TreeUtils.iconClick({
                    item: { ...item, key: 'delete' },
                    _this,
                    langJson,
                    currentKey: 'delete',
                    onClick: () => {
                        item.disabled !== true && this.delRender.call(this, item, e);
                        callback && callback();
                    },
                });
            }}
        >
            <i className="icon iconfont icon-shanchu delete-icon" />
            <span className="icon-right-title">{nodeIconTooltips.delete || langJson['tree-node-icon-delete']}</span>
        </span>;

    }

    // 点击删除图标事件，删除节点
    delRender = (item, e) => {
        let { showModal = true, store, clickDelIconEve, treeType, delNodeCallBack, triggerSelectWhenClickIcon, onSelectEve } = this.props;
        let { langJson } = this.state;
        let needEdit = store.getStore('needEdit');
        e.stopPropagation();
        this.setState({ isActive_del: true });
        store.setCache('currentNode', item);
        if (showModal) {

            store.setCache('treeNodeOperation', 'del');
            store.setStore('showEditModal', true);
        } else if (treeType === 'asyncTree') {
            if (isFunction(delNodeCallBack)) {
                delNodeCallBack(item);
            }
        }

        if (triggerSelectWhenClickIcon && isFunction(onSelectEve)) {
            onSelectEve(item.refpk, item);
            store.setStore('selectedKeys', [item.refpk]);
        }
        if (isFunction(clickDelIconEve)) {
            clickDelIconEve(item);
        }
        if (needEdit && showModal && Object.keys(langJson).length > 0) {
            promptBox({
                color: 'warning',
                title: this.props[`delModalTitle`] || langJson[`containers-tree-del`],
                content: langJson["containers-tree-003"],
                hasCloseBtn: true,
                beSureBtnClick: this.beSureBtnClick,
                cancelBtnClick: this.cancelBtnClick,
            });
        }

        store.setStateEve();
    };

    beSureBtnClick = () => {
        let { treeType, store } = this.props;
        let status = store.getCache('treeNodeOperation');
        store.setStore('showEditModal', false);
        this.setState({ [`isActive_${status}`]: false, [`showIconBg_${status}`]: false });
        if (treeType === 'asyncTree') {
            if (isFunction(this.props[`${status}NodeCallBack`])) {
                let currentNode = store.getCache('currentNode');
                let formStore = store.getStore('formStore');
                this.props[`${status}NodeCallBack`](
                    currentNode,
                    formStore.getAllFormValue(),
                );
            }
        } else if (treeType === 'syncTree') {
            this[`${status}NodeEve`]();
        }
    }

    cancelBtnClick = () => {
        let { verifyModalForm, store } = this.props;
        let status = store.getCache('treeNodeOperation');
        this.setState({ [`isActive_${status}`]: false, [`showIconBg_${status}`]: false });
        let formStore = store.getStore('formStore');
        if (!verifyModalForm) {
            formStore.setStatus("browse");
        }
        formStore.cancel();
        store.setStore('showEditModal', false);
        store.setStateEve();
    }

    getTreeNodesLazy = treeData => {

        //这里去tinper的treeData有bug  tinper给的treeData是上一次的bee-tree的state数据
        //传给tinper的treeData引用相同 数据未改变时 没有更新 因为tinper内部对比的引用
        // let { store } = this.props;
        // let treeData = store.getStore('treeData');
        //更新treeData时 目前给的新数据
        return this.loopLazy(treeData, 0);
    }

    // 组织节点dom
    loopLazy = (data, nodeLevel) => {
        let { store, neverDisable = false, switcherClass, mustExpandable = false } = this.props;
        let expandedKeys = store.getStore('expandedKeys');
        let selectedKeys = store.getStore('selectedKeys');

        let newData = data || [];
        return newData.map(item => {
            item.key = item.refpk;
            if (item.key === undefined) {
                console.error('树组件，数据格式错误， 缺少refpk字段，请检查数据格式');
                return false;
            }
            let fieldid = '';
            if (item.attrcode) {
                fieldid = `${item.attrcode}_node`;
            } else if (item.beforeName && typeof item.beforeName === 'string') {
                fieldid = `${item.beforeName.trim()}_node`;
            } else if (item.refname) {
                if (typeof item.refname === "string") {
                    let refnameArr = item.refname.split(' ');
                    let refname = refnameArr[0];
                    if (!refname && refnameArr[1]) {
                        refname = refnameArr[1];
                    }
                    fieldid = `${refname}_node`;
                } else {
                    fieldid = `${item.refpk || item.key || item.id}_node`;
                }
            }
            if (Array.isArray(item.children) && item.children.length) {
                return (
                    <TreeNode
                        liAttr={{ fieldid: getSysFieldid(fieldid), key: fieldid }}
                        {...item}
                        className={classnames(
                            `node-item ${item.className || ''}`,
                            { isexpend: expandedKeys.includes(item.key) },
                            { disabledSelected: selectedKeys[0] === item.refpk },
                            { nodeDisabled: item.disabled === true },
                        )}

                        // className={item.isdrag === false ? 'noDrag' : null}
                        key={item.key}
                        title={this.renderTreeTitle(item, nodeLevel)}
                        disabled={neverDisable ? false : item.disabled}
                        switcherClass={item.switcherClass || switcherClass}
                        mustExpandable={item.mustExpandable || mustExpandable}
                        isLeaf={item.isLeaf}
                    //icon={this.getFloadIcon(item)}
                    >
                        {this.loop(item.children, nodeLevel + 1)}
                    </TreeNode>
                );
            } else {
                if (item.isleaf === false) {
                    return (
                        <TreeNode
                            liAttr={{ fieldid: getSysFieldid(fieldid), key: fieldid }}
                            {...item}
                            className={classnames(
                                `node-item ${item.className || ''}`,
                                { isexpend: expandedKeys.includes(item.key) },
                                { disabledSelected: selectedKeys[0] === item.refpk },
                                { nodeDisabled: item.disabled === true },
                            )}
                            key={item.key}
                            title={this.renderTreeTitle(item, nodeLevel)}
                            disabled={neverDisable ? false : item.disabled}
                            switcherClass={item.switcherClass || switcherClass}
                            children={[]}
                            mustExpandable={item.mustExpandable || mustExpandable}
                            isLeaf={false}
                        //icon={this.getFloadIcon(item)}
                        />
                    );
                } else {
                    return (
                        <TreeNode
                            liAttr={{ fieldid: getSysFieldid(fieldid), key: fieldid }}
                            {...item}
                            className={classnames(
                                `node-item ${item.className || ''}`,
                                { isexpend: expandedKeys.includes(item.key) },
                                { disabledSelected: selectedKeys[0] === item.refpk },
                                { nodeDisabled: item.disabled === true },
                            )}
                            key={item.key}
                            title={this.renderTreeTitle(item, nodeLevel)}
                            disabled={neverDisable ? false : item.disabled}
                            switcherClass={item.switcherClass || switcherClass}
                            children={null}
                            mustExpandable={item.mustExpandable || mustExpandable}
                            isLeaf={true}
                        //icon={this.getFloadIcon(item)}
                        />
                    );
                }
            }
        });
    };

    getTreeNodes = treeData => {

        //这里去tinper的treeData有bug  tinper给的treeData是上一次的bee-tree的state数据
        //传给tinper的treeData引用相同 数据未改变时 没有更新 因为tinper内部对比的引用
        // let { store } = this.props;
        // let treeData = store.getStore('treeData');
        //更新treeData时 目前给的新数据
        return this.loop(treeData, 0);
    }

    // 组织节点dom
    loop = (data, nodeLevel) => {
        let {
            store,
            neverDisable = false,
            switcherClass, mustExpandable = false,
            showCheckboxWhenDisabled = true,
            hideTreeIcon = false,
            needChangeChildren = false,
        } = this.props;
        let expandedKeys = store.getStore('expandedKeys');
        let selectedKeys = store.getStore('selectedKeys');

        let newData = data || [];
        //const switcherStyle = { border: 'none' };
        return newData.map(item => {
            item.key = item.refpk;
            //item.switcherStyle = switcherStyle;
            if (item.key === undefined) {
                console.error('树组件，数据格式错误， 缺少refpk字段，请检查数据格式');
                return false;
            }
            let fieldid = '';
            if (item.attrcode) {
                fieldid = `${item.attrcode}_node`;
            } else if (item.beforeName && typeof item.beforeName === 'string') {
                fieldid = `${item.beforeName.trim()}_node`;
            } else if (item.refname) {
                if (typeof item.refname === "string") {
                    let refnameArr = item.refname.split(' ');
                    let refname = refnameArr[0];
                    if (!refname && refnameArr[1]) {
                        refname = refnameArr[1];
                    }
                    fieldid = `${refname}_node`;
                } else {
                    fieldid = `${item.refpk || item.key || item.id}_node`;
                }
            }
            if ((item.disabled && !showCheckboxWhenDisabled) || (item.visibleCheckbox===false)) {
                item.visibleCheckbox = false;
            } else {
                item.visibleCheckbox = true;
            }
            //图标问题 支持隐藏
            item.icon = () => hideTreeIcon ? <Fragment></Fragment> : this.getFloadIcon(item);

            if (Array.isArray(item.children) && (item.children.length || this.props.treeType === "asyncTree")) {
                return (
                    <TreeNode
                        liAttr={{ fieldid, key: fieldid }}
                        {...item}
                        className={classnames(
                            `node-item ${item.className || ''} base-tree-node-cls`,
                            { isexpend: expandedKeys.includes(item.key) },
                            { disabledSelected: selectedKeys[0] === item.refpk },
                            { nodeDisabled: item.disabled === true },
                        )}

                        // className={item.isdrag === false ? 'noDrag' : null}
                        key={item.key}
                        title={this.renderTreeTitle(item, nodeLevel)}
                        disabled={neverDisable ? false : item.disabled}
                        switcherClass={item.switcherClass || switcherClass}
                        mustExpandable={item.mustExpandable || mustExpandable}
                        fieldid={fieldid}
                        titleClass="base-tree-node-title"
                        switcherClass="base-tree-node-switch"
                    >
                        {this.loop(item.children, nodeLevel + 1)}
                    </TreeNode>
                );
            } else {
                if (item.isleaf === false) {
                    if (needChangeChildren) {
                        item.children = item.children || [];
                    }
                    return (
                        <TreeNode
                            liAttr={{ fieldid, key: fieldid }}
                            {...item}
                            className={classnames(
                                `node-item ${item.className || ''} base-tree-node-cls`,
                                { isexpend: expandedKeys.includes(item.key) },
                                { disabledSelected: selectedKeys[0] === item.refpk },
                                { nodeDisabled: item.disabled === true },
                            )}
                            key={item.key}
                            title={this.renderTreeTitle(item, nodeLevel)}
                            disabled={neverDisable ? false : item.disabled}
                            switcherClass={item.switcherClass || switcherClass}
                            mustExpandable={item.mustExpandable || mustExpandable}
                            fieldid={fieldid}
                            children={[]}
                            titleClass="base-tree-node-title"
                            isLeaf={item.isleaf}
                            switcherClass="base-tree-node-switch"
                        />
                    );
                } else {
                    if (needChangeChildren) {
                        item.children = item.children || null;
                    }
                    return (
                        <TreeNode
                            liAttr={{ fieldid, key: fieldid }}
                            {...item}
                            className={classnames(
                                `node-item ${item.className || ''} base-tree-node-cls`,
                                { isexpend: expandedKeys.includes(item.key) },
                                { disabledSelected: selectedKeys[0] === item.refpk },
                                { nodeDisabled: item.disabled === true },
                            )}
                            key={item.key}
                            title={this.renderTreeTitle(item, nodeLevel)}
                            disabled={neverDisable ? false : item.disabled}
                            switcherClass={item.switcherClass || switcherClass}
                            mustExpandable={item.mustExpandable || mustExpandable}
                            fieldid={fieldid}
                            children={null}
                            titleClass="base-tree-node-title"
                            isLeaf={true}
                            switcherClass="base-tree-node-switch"
                        />
                    );
                }
            }
        });
    };

    getScrollContainer = () => {
        if (this.treeDiv) {
            return this.treeDiv;
        } else {
            let treeDiv = document.querySelector(`#${this.props.treeId.trim()}`);
            if (treeDiv) {
                this.treeDiv = treeDiv.querySelector('.tree-hotkeys-wrapper');
            } else {
                this.treeDiv = document.querySelector('.tree-hotkeys-wrapper');
            }
            return this.treeDiv;
        }
    }

    render() {

        let {
            treeId,
            userDefine,
            needSearch = true, //是否显示搜索
            getSearchVal,
            disabledSearch = false,
            checkable = false,
            checkStrictly = true,
            draggable = false,
            store,
            mustExpandable = false, //支持disabled的节点可以自定义展开收起，默认disabled的节点不可以展开收起。
            lazyLoad = false,
            expandWhenDoubleClick,
            showLine = true,
            treeType,
            otherAreaHeight = 0,
            canCloseFreely = true,
            searchChangeEve,
            openAnimation = true,
            resetExpandedKeysWhenInput = false, // input 输入搜索时是否清空展开节点
            expandParent = true, // input 输入搜索时是否展开非叶子节点
        } = this.props;

        let { langJson } = this.state;
        let searchValue = store.getStore('searchValue');
        let focusable = store.getStore('focusable');
        let selectedKeys = store.getStore('selectedKeys');
        let expandedKeys = store.getStore('expandedKeys');
        let autoExpandParent = store.getStore('autoExpandParent');
        let checkedKeys = store.getStore('checkedKeys') || [];
        let halfCheckedKeys = store.getStore('halfCheckedKeys');
        if (Array.isArray(halfCheckedKeys)) {
            checkedKeys = { checked: [...checkedKeys], halfChecked: [...halfCheckedKeys] };
        }

        let treeData = store.getStore('treeData');

        return (
            <div
                fieldid={getSysFieldid(`${treeId}_tree-area`)}
                className="syncTreeCom"
                id={treeId}
            >
                {isFunction(userDefine) && userDefine()}
                {
                    needSearch &&
                    <div className="NC_syncTreeSearch">
                        <input
                            ref={ref => { this.searchInputRef = ref; this.searchRef.current = ref; }}
                            className={`sync-tree-input ${tinperClsPrefix}-input md`}
                            fieldid="search"
                            style={{ "width": "100%", "height": 26, "padding-right": "50px" }}
                            placeholder={langJson["containers-tree-001"]}
                            onClick={() => {
                                if (this.ncc_automated === "1") {
                                    if (searchValue == "") { return; }
                                    store.searchChange(searchValue);
                                    store.setStateEve();
                                }
                            }}
                            onChange={event => {
                                let value = event.target.value;
                                if (value == "" || value.trim() == "") {
                                    if (isFunction(searchChangeEve) && treeType === "asyncTree"){
                                        console.log('');
                                    }else{
                                        // 处理清空状态
                                        this.handleClearState();
                                        if (isFunction(getSearchVal)) {
                                            getSearchVal((value.trim()));
                                        }
                                        if (isFunction(searchChangeEve)) {
                                            searchChangeEve((value.trim()));
                                        }
                                        // if (treeType === "syncTree") {
                                        //     store.searchChange('', true, resetExpandedKeysWhenInput, expandParent);
                                        // }
                                        // return false;
                                    }

                                }
                                // if (this.ncc_automated != "1") {
                                // 处理搜索空值
                                this.interval = new Date().getTime();
                                let s = setTimeout(() => {
                                    if (new Date().getTime() - this.interval >= 500 && treeType === "syncTree") {
                                        store.searchChange(value.trim(), true, resetExpandedKeysWhenInput, expandParent);
                                    }
                                    if (isFunction(getSearchVal)) {
                                        getSearchVal((value.trim()));
                                    }
                                    if (isFunction(searchChangeEve)) {
                                        searchChangeEve((value.trim()));
                                    }
                                    clearTimeout(s);
                                }, 500);
                                // }
                                searchValue = value.trim();
                                store.setStore('searchValue', searchValue);
                            }}
                            onFocus={this.focusEve.bind(this)}
                            disabled={disabledSearch}
                            onBlur={this.blurEve}
                        />

                        <i className="icon iconfont icon-sousuo syncTreeSearchIcon" />

                        {
                            searchValue !== "" &&
                            <i
                                style={disabledSearch ? { display: "none" } : null}
                                className="icon iconfont qingkong syncTreeSearchIcon icon-qingkong"
                                onClick={this.handleClearSearchVal}
                            />
                        }
                    </div>
                }

                <div
                    fieldid={getSysFieldid(`${treeId}_tree`)}
                    className="synctree-area"
                    ref={this.treeRef}
                >
                    <Tree
                        lazyLoad={lazyLoad}
                        renderTreeNodes={lazyLoad ? this.getTreeNodes : null}
                        // renderTreeNodes={this.getTreeNodes}
                        treeId={treeId}
                        treeData={treeData}
                        focusable={focusable}
                        mustExpandable={mustExpandable}
                        onDoubleClick={this.onDoubleClickHandler}
                        selectedKeys={selectedKeys}
                        onSelect={this.onSelect}
                        onExpand={this.onExpand} // 节点展开事件
                        expandedKeys={expandedKeys} //搜索节点关键字后要展开的父节点
                        autoExpandParent={autoExpandParent} //是否展开所有节点
                        onMouseLeave={this.onMouseLeave} //鼠标离开节点事件
                        onMouseEnter={this.onMouseEnter} // 鼠标进入节点事件
                        onCheck={this.onCheck}
                        checkable={checkable}
                        checkStrictly={checkStrictly}
                        checkedKeys={checkedKeys || []}
                        draggable={draggable}
                        debounceDuration={5}
                        onDragOver={this.onDragOver.bind(this)}
                        onDragEnter={this.onDragEnter}
                        onDragStart={this.onDragStart.bind(this)}
                        onDrop={this.onDrop}
                        onDragEnd={this.onDragEnd}
                        getScrollContainer={this.getScrollContainer}
                        otherAreaHeight={otherAreaHeight}
                        //异步树API
                        expandWhenDoubleClick={expandWhenDoubleClick}
                        loadData={treeType === 'asyncTree' ? this.onLoadData : null}
                        showLine={showLine}
                        canCloseFreely={canCloseFreely}//解决层层收起失效问题
                        syncCheckedAndSelectedStatus={false}//默认不开启选择和勾选同步触发
                        cancelUnSelect={false} //点击节点可切换选中状态
                        openAnimation={openAnimation ? undefined : {}}// 是否需要动画
                        resetExpandedKeysWhenInput={resetExpandedKeysWhenInput}
                    >
                        {lazyLoad ? null : this.getTreeNodes(treeData)}
                    </Tree>
                </div>
            </div>
        );
    }
}

class TreeNodeIcon extends React.Component {
    state = {};
    /**
   * 处理图标鼠标悬浮事件---添加背景色
   */
    handleIconOver = type => {
        this.setState({ [`showIconBg_${type}`]: true });
    }

    /**
     * 处理图标鼠标移走事件 ---移除背景色
     */
    handleIconLeave = type => {
        let isActive = this.state[`isActive_${type}`];
        !isActive && this.setState({ [`showIconBg_${type}`]: false });
    }

    getEditIcon = item => {
        let { nodeIconTooltips = {}, langJson, _this } = this.props;
        if (item && item.iconBox && item.iconBox.editIcon) {
            return <TreeNodeToolTip
                overlay={nodeIconTooltips.edit || langJson['tree-node-icon-edit']}
            >
                <span className={classnames('tree-icon-wrapper', { 'show-background': this.state.showIconBg_edit === true })}
                    onMouseOver={() => this.handleIconOver("edit")} onMouseLeave={() => this.handleIconLeave("edit")}>
                    <i
                        className="icon iconfont icon-bianji edit-icon"
                        onClick={e => {
                            TreeUtils.iconClick({
                                item: { ...item, key: 'edit' },
                                _this,
                                langJson,
                                currentKey: 'edit',
                                onClick: () => { item.disabled !== true && this.editRender.call(this, item, e); },
                            });
                        }}
                    />
                </span>
            </TreeNodeToolTip>;
        }
        return null;
    }

    getAddIcon = item => {
        let { nodeIconTooltips = {}, langJson, _this } = this.props;
        if (item && item.iconBox && item.iconBox.addIcon) {
            return <TreeNodeToolTip
                overlay={nodeIconTooltips.add || langJson['tree-node-icon-add']}
            >
                <span className={classnames('tree-icon-wrapper', { 'show-background': this.state.showIconBg_add === true })}
                    onMouseOver={() => this.handleIconOver("add")} onMouseLeave={() => this.handleIconLeave("add")}>
                    <i
                        className="icon iconfont icon-zengjia add-icon"
                        onClick={e => {
                            TreeUtils.iconClick({
                                item: { ...item, key: 'add' },
                                _this,
                                langJson,
                                currentKey: 'add',
                                onClick: () => { item.disabled !== true && this.addRender(item, e); },
                            });
                        }}
                    />
                </span>
            </TreeNodeToolTip>;
        }
        return null;
    }

    getDelIcon = item => {
        let { nodeIconTooltips = {}, langJson, _this } = this.props;
        if (item && item.iconBox && item.iconBox.delIcon) {
            return <TreeNodeToolTip
                overlay={nodeIconTooltips.delete || langJson['tree-node-icon-delete']}
            >
                <span className={classnames('tree-icon-wrapper', { 'show-background': this.state.showIconBg_del === true })}
                    onMouseOver={() => this.handleIconOver("del")} onMouseLeave={() => this.handleIconLeave("del")}>
                    <i
                        className="icon iconfont icon-shanchu delete-icon"
                        onClick={e => {
                            TreeUtils.iconClick({
                                item: { ...item, key: 'delete' },
                                _this,
                                langJson,
                                currentKey: 'delete',
                                onClick: () => { item.disabled !== true && this.delRender.call(this, item, e); },
                            });
                        }}
                    />
                </span>
            </TreeNodeToolTip>;
        }
        return null;
    }

    //  点击新增图标事件
    addRender = (item, e) => {
        e.stopPropagation();
        this.setState({ isActive_add: true });
        let { showModal = true, store, clickAddIconEve, addNodeCallBack, treeType, triggerSelectWhenClickIcon, onSelectEve } = this.props;
        store.setCache('currentNode', item);

        if (showModal) {
            let formStore = store.getStore('formStore');
            formStore.emptyAllFormValue();
            formStore.setStatus('edit');

            store.setCache('treeNodeOperation', 'add');
            store.setStore('showEditModal', true);
            store.setStateEve();
        } else {
            this.setState({ isActive_add: false, showIconBg_add: false });
            if (treeType === 'asyncTree') {
                if (isFunction(addNodeCallBack)) {
                    addNodeCallBack(item);
                }
            }
        }
        if (triggerSelectWhenClickIcon && isFunction(onSelectEve)) {
            onSelectEve(item.refpk, item);
            store.setStore('selectedKeys', [item.refpk]);
            store.setCache('selectedNode', item);
        }

        if (isFunction(clickAddIconEve)) {
            clickAddIconEve(item);
        }
        store.setStateEve();
    };

    editRender = (item, e) => {
        let { showModal = true, store, clickEditIconEve, treeType, editNodeCallBack, triggerSelectWhenClickIcon, onSelectEve } = this.props;
        e.stopPropagation();
        this.setState({ isActive_edit: true });
        store.setCache('currentNode', item);
        if (showModal) {
            let formStore = store.getStore('formStore');
            formStore.emptyAllFormValue();
            formStore.setStatus('edit');

            store.setCache('treeNodeOperation', 'edit');
            store.setStore('showEditModal', true);

        } else {
            this.setState({ isActive_edit: false, showIconBg_edit: false });
            if (treeType === 'asyncTree') {
                if (isFunction(editNodeCallBack)) {
                    editNodeCallBack(item);
                }
            }
        }

        if (isFunction(clickEditIconEve)) {
            clickEditIconEve(item);
        }
        if (triggerSelectWhenClickIcon && isFunction(onSelectEve)) {
            store.setCache('selectedNode', item);
            onSelectEve(item.refpk, item);
            store.setStore('selectedKeys', [item.refpk]);
        }
        store.setStateEve();
    }

    // 点击删除图标事件，删除节点
    delRender = (item, e) => {
        let { showModal = true, store, clickDelIconEve, treeType, delNodeCallBack, triggerSelectWhenClickIcon, onSelectEve, langJson } = this.props;
        let needEdit = store.getStore('needEdit');
        e.stopPropagation();
        this.setState({ isActive_del: true });
        store.setCache('currentNode', item);
        if (showModal) {
            store.setCache('treeNodeOperation', 'del');
            store.setStore('showEditModal', true);
        } else {
            this.setState({ isActive_del: false, showIconBg_del: false });
            if (treeType === 'asyncTree') {
                if (isFunction(delNodeCallBack)) {
                    delNodeCallBack(item);
                }
            }
        }

        if (triggerSelectWhenClickIcon && isFunction(onSelectEve)) {
            onSelectEve(item.refpk, item);
            store.setStore('selectedKeys', [item.refpk]);
        }
        if (isFunction(clickDelIconEve)) {
            clickDelIconEve(item);
        }
        if (needEdit && showModal && Object.keys(langJson).length > 0) {
            promptBox({
                color: 'warning',
                title: this.props[`delModalTitle`] || langJson[`containers-tree-del`],
                content: langJson["containers-tree-003"],
                hasCloseBtn: true,
                beSureBtnClick: this.beSureBtnClick,
                cancelBtnClick: this.cancelBtnClick,
            });
        }

        store.setStateEve();
    };

    changeStateStatus = () => {
        let { store } = this.props;
        let status = store.getCache('treeNodeOperation');
        this.setState({ [`isActive_${status}`]: false, [`showIconBg_${status}`]: false });
    }

    beSureBtnClick = () => {
        let { treeType, store, verifyModalForm } = this.props;
        let status = store.getCache('treeNodeOperation');

        if (treeType === 'asyncTree') {
            if (isFunction(this.props[`${status}NodeCallBack`])) {
                let currentNode = store.getCache('currentNode');
                let formStore = store.getStore('formStore');
                let verify = this.props[`${status}NodeCallBack`](
                    currentNode,
                    formStore.getAllFormValue(),
                );
                if (verifyModalForm && verify) {
                    store.setStore('showEditModal', false);
                    this.changeStateStatus();
                }
            }
        } else if (treeType === 'syncTree') {
            this[`${status}NodeEve`]();
        }
    }

    cancelBtnClick = () => {
        let { verifyModalForm, store } = this.props;
        let status = store.getCache('treeNodeOperation');
        this.setState({ [`isActive_${status}`]: false, [`showIconBg_${status}`]: false });
        let formStore = store.getStore('formStore');
        if (!verifyModalForm) {
            formStore.setStatus("browse");
        }
        formStore.cancel();
        store.setStore('showEditModal', false);
        store.setStateEve();
    }

    //-------------树节点编辑模态框事件 ---------------//

    editNodeEve = item => {
        let { verifyModalForm = false, editNodeCallBack, store, triggerSelectWhenClickIcon, onSelectEve } = this.props;
        let currentNode = store.getCache('currentNode');
        let formStore = store.getStore('formStore');
        if (!verifyModalForm) {
            formStore.setStatus('browse');
            store.setStore('showEditModal', false);
            this.changeStateStatus();
        }
        let data = formStore.getAllFormValue();
        if (isFunction(editNodeCallBack)) {
            let verify = editNodeCallBack(data, currentNode.refpk, currentNode);
            // 如果有回调 并且进行了校验
            if (verifyModalForm && verify) {
                store.setStore('showEditModal', false);
                this.changeStateStatus();
                store.setStateEve();
            }
        }
        if (triggerSelectWhenClickIcon && isFunction(onSelectEve)) {
            onSelectEve(item.refpk, item);
        }
    }

    addNodeEve = () => {
        let { verifyModalForm = false, addNodeCallBack, store } = this.props;
        let currentNode = store.getCache('currentNode');
        let formStore = store.getStore('formStore');

        if (!verifyModalForm) {
            formStore.setStatus('browse');
            store.setStore('showEditModal', false);
            this.changeStateStatus();
        }
        let data = formStore.getAllFormValue();

        if (isFunction(addNodeCallBack)) {
            let verify = addNodeCallBack(data, currentNode.refpk, currentNode);
            // 如果有回调 并且进行了校验
            if (verifyModalForm && verify) {
                store.setStore('showEditModal', false);
                this.changeStateStatus();
                store.setStateEve();
            }
        }
    };

    delNodeEve = () => {
        let { delNodeCallBack, store } = this.props;
        let currentNode = store.getCache('currentNode');
        isFunction(delNodeCallBack) && delNodeCallBack(currentNode);
    }

    render() {
        let {
            type,
            item,
            showModal = true,
            verifyModalForm = false,
            modalSize,
            meta,
            metaId,
            store,
            langJson,
            modalConfig = {},
        } = this.props;
        let status = store.getCache('treeNodeOperation');
        let showEditModal = store.getStore('showEditModal');
        let editModalTitle = this.props[`${status}ModalTitle`] || langJson[`containers-tree-${status}`];
        let formStore = store.getStore('formStore');
        let needEdit = store.getStore('needEdit');
        let show = this.state["isActive_" + status] && needEdit && showModal && Object.keys(langJson).length > 0 && status !== 'del';
        let { closeButton, useHotkey } = modalConfig;
        let comp = null;
        if (type === 'add') {
            comp = this.getAddIcon(item);
        } else if (type === 'edit') {
            comp = this.getEditIcon(item);
        } else if (type === 'del') {
            comp = this.getDelIcon(item);
        }
        return (
            <Fragment>
                {comp}
                {useHotkey && <HotKeys
                    keyMap={{ btnSure: ["Alt+Y"], btnCancel: ["Alt+N"] }}
                    handlers={{
                        btnSure: () => {
                            this.beSureBtnClick();
                        },
                        btnCancel: () => {
                            this.cancelBtnClick();
                        },
                    }}
                    className="dragwidth-hotkeys-wrapper"
                    focused={true}
                    attach={document.body}
                    display="inline"
                >
                </HotKeys>
                }
                {
                    show && <Modal
                        fieldid={`${status}Node`}
                        visible={showEditModal}
                        mask={"static"}
                        size={status !== 'del' && modalSize}
                        userControl={status !== 'del' && verifyModalForm}
                        onExited={this.cancelBtnClick}
                    >
                        <Modal.Header clsPrefix='wui-modal-header' closeButton={closeButton}>
                            <Modal.Title
                                fieldid={editModalTitle}
                            >
                                {editModalTitle}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body clsPrefix='wui-modal-body'>
                            {
                                status === 'del' ?
                                    langJson["containers-tree-003"] :
                                    <div className="addModal">
                                        <Form
                                            name={metaId}
                                            config={{}}
                                            store={formStore}
                                            getHotKeyConfig={() => {
                                                return { meta };
                                            }}
                                        />
                                    </div>
                            }
                        </Modal.Body>
                        <Modal.Footer clsPrefix='wui-modal-footer'>
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${langJson['containers-tree-sure-btn']}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                                trigger={['hover', 'focus']}
                                className="model-helper-overlay"
                            >
                                <Button
                                    onClick={this.beSureBtnClick}
                                    colors="primary"
                                    style={{ marginRight: 8 }}>
                                    {`${langJson['containers-tree-sure-btn']}`}({<span className="text-decoration-underline">Y</span>})
                                </Button>
                            </Tooltip>
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${langJson['containers-tree-cancel-btn']}  (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                                trigger={['focus', 'hover']}
                                className="model-helper-overlay"
                            >
                                <Button
                                    onClick={this.cancelBtnClick}
                                    bordered
                                >
                                    {`${langJson['containers-tree-cancel-btn']}`}({<span className="text-decoration-underline">N</span>})
                                </Button>
                            </Tooltip>
                        </Modal.Footer>
                    </Modal>
                }
            </Fragment>
        );
    }
}